import { Link } from 'react-router-dom';
import styled from 'styled-components/macro';

import { AvatarWrapStyled } from 'components/Avatar/Avatar.styled';
import ButtonIcon from 'components/ButtonIcon/ButtonIcon';
import FlexContainer from 'components/FlexContainer/FlexContainer';

export const HeaderStyled = styled(FlexContainer)`
  width: 100%;
  padding: 1.5rem;
  gap: 1rem;
  background: ${({ theme }) => theme.colors.primary.variant1};
  box-shadow: ${({ theme }) => theme.shadows.variant1};
`;

export const LinkStyled = styled(Link)`
  img {
    transition: filter 0.3s;
  }
  &:hover img {
    filter: ${({ theme }) => theme.filters.whiteToViolet};
  }
`;
export const MainContainerStyled = styled.section`
  max-width: 1080px;
  margin: 0 auto;
  background: ${({ theme }) => theme.colors.white};
  padding: 2rem;
  min-height: 100vh;

  ${({ theme }) => `
    ${theme.devices.tablet} {
      padding: 4rem;
    }
  `}

  ${AvatarWrapStyled} {
    margin-top: 2rem;
  }
`;

export const FlexContainerStyled = styled(FlexContainer)`
  position: relative;
`;

export const ButtonIconStyled = styled(ButtonIcon)`
  position: absolute;
  top: 32px;
  left: 180px;
`;
